module.exports = __webpack_public_path__ + "img/prev.bc5174b4.png";